import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Login from "./components/frontend/auth/Login";
import Register from "./components/frontend/auth/Register";
import Password from "./components/frontend/auth/Password";
import Home from "./components/frontend/Home";
import ResetPassword from "./components/frontend/auth/ResetPassword";
import WebsiteHome from "../src/websitecomponents/pages/Home";
import MasterLayout from "../src/layout/admin/MasterLayout";
import { Provider } from "react-redux";
import store from "./websitecomponents/redux/store";
import { ToastContainer } from "react-toastify";
import NavbarScreen from "./websitecomponents/pages/NavBar/NavbarScreen";
import AllProductData from "./websitecomponents/pages/AllProductData";
import Cart from "./websitecomponents/pages/cart";
import AboutUs from "./websitecomponents/pages/AboutUs";
import ContactUs from "./websitecomponents/pages/ContactUs";
import OrderPlace from "./websitecomponents/pages/OrderPlace";
import Wishlist from "./websitecomponents/pages/Wishlist";
import Checkout from "./websitecomponents/pages/Checkout";
import Profile from "./components/admin/Profile";
import WebLogin from "./websitecomponents/pages/Login";
import WebRegister from "./websitecomponents/pages/NavBar/Register";
import ReturnPolicy from "./websitecomponents/FooterInformation.jsx/ReturnPolicy";
import Delivery from "./websitecomponents/FooterInformation.jsx/Delivey";
import ShippingPolicy from "./websitecomponents/FooterInformation.jsx/ShippingPolicy";
import PaymentPolicy from "./websitecomponents/FooterInformation.jsx/PaymentsPolicy";
import DisclaimerPolicy from "./websitecomponents/FooterInformation.jsx/DisclaimerPolicy";
import PrebookingPolicy from "./websitecomponents/FooterInformation.jsx/PrebookingPolicy";
import RefundReturn from "./websitecomponents/FooterInformation.jsx/Refund&Return";
import PrivacyPolicy from "./websitecomponents/FooterInformation.jsx/PrivacyPolicy";
import FAQ from "./websitecomponents/FooterInformation.jsx/FAQ";
import UseIt from "./websitecomponents/FooterInformation.jsx/UseIt";
import TermsOfServices from "./websitecomponents/FooterInformation.jsx/TermsOfServices";
import AllOrders from "./websitecomponents/pages/AllOrder";
import SellerDashboard from "./websitecomponents/pages/SellerPages/SellerDashboard";
import SellerRegister from "./websitecomponents/pages/SellerPages/SellerRegister";
import GstRegistration from "./websitecomponents/pages/SellerPages/GstRegistration";
import SellerLogin from "./websitecomponents/pages/SellerPages/SellerLogin";
import ThankYouPage from "./websitecomponents/pages/ThankYouPage";
import TopSellDetails from "./websitecomponents/pages/TopSellDetails";
import CancelAndReturn from "./websitecomponents/FooterInformation.jsx/cancelandreturn";
import ProductDetails from "./websitecomponents/pages/productdetails";
import ShowSubCategory from "./websitecomponents/pages/Categories/ShowSubCategory";
import ViewAllCategory from "./websitecomponents/pages/Categories/ViewAllCategory";
import ShowCategoryData from "./websitecomponents/pages/Categories/ShowCategoryData";
import { v4 as uuidv4 } from "uuid";
import Address from "./websitecomponents/pages/address";
import Getaddress from "./websitecomponents/pages/getaddress";
import Coupons from "./websitecomponents/pages/Coupons";
import OtpScreen from "./websitecomponents/pages/otpscreen";
import TitleManager from "./websitecomponents/pages/titlemaneger";
import GetcategorySubcategory from "./websitecomponents/pages/getcategorysubcategory";
import ViewAllBrand from "./websitecomponents/pages/viewAllBrand";
import ShowBrandData from "./websitecomponents/pages/showBrandData";
import EditProducts from "./components/admin/products/EditProducts";
import EditCategory from "./components/admin/category/EditCategory";

function App() {
  const location = useLocation();

  useEffect(() => {
    const EXPIRY_LIMIT = 2 * 60 * 60 * 1000;
    const now = Date.now();

    const token = localStorage.getItem("authToken");
    const uuid = localStorage.getItem("uuid");
    const uuidTime = localStorage.getItem("uuidTime");

    if (
      !token &&
      (!uuid || !uuidTime || now - parseInt(uuidTime) > EXPIRY_LIMIT)
    ) {
      const newUuid = uuidv4();
      localStorage.setItem("uuid", newUuid);
      localStorage.setItem("uuidTime", now.toString());
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const EXPIRY_LIMIT = 24 * 60 * 60 * 1000;
    const now = Date.now();

    const token = localStorage.getItem("authToken");
    const tokenTime = localStorage.getItem("authTokenTime");

    if (token && tokenTime) {
      if (now - parseInt(tokenTime) > EXPIRY_LIMIT) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("authTokenTime");
        localStorage.removeItem("userId");
        localStorage.removeItem("orderID");
        localStorage.removeItem("uuid");
        localStorage.removeItem("uuidTime");
        window.location.reload();
      }
    }
  }, []);


  const hideNavbarRoutes = [
    "/bharatcod-admin",
    "/Register",
    "/Login",
    "/Password",
    "/ResetPassword",
    "/admin",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // If you want to also hide it for any route starting with /admin
  const shouldHideNavbar = hideNavbarRoutes.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <div className="App">
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1T17EG7TVZ"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1T17EG7TVZ');
          `}
        </script>
      </Helmet>
      <ToastContainer />
      <Provider store={store}>
        {!shouldHideNavbar && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              zIndex: 10,
              backgroundColor: "white",
              borderBottom: "1px solid lightgray",
            }}
          >
            <NavbarScreen />
          </div>
        )}

        <TitleManager />

        <div style={{ marginTop: "75px" }}>
          <Routes>
            <Route path="/" element={<WebsiteHome />} />
            <Route path="/bharatcod-admin" element={<Home />} />
            <Route path="Register" element={<Register />} />
            <Route path="Login" element={<Login />} />
            <Route path="Password" element={<Password />} />
            <Route path="ResetPassword" element={<ResetPassword />} />
            <Route path="admin/*" element={<MasterLayout />} />
            <Route path="/admin/edit/:id" element={<EditProducts />} />
            <Route path="/admin/EditCategory/:id" element={<EditCategory />} />
            <Route path="AllProductData" element={<AllProductData />} />
            <Route path="/Cart" element={<Cart />} />
            <Route path="/about-us/" element={<AboutUs />} />
            <Route path="/contact-us/" element={<ContactUs />} />
            <Route path="/OrderPlace" element={<OrderPlace />} />
            <Route path="/Wishlist" element={<Wishlist />} />
            <Route path="/Checkout" element={<Checkout />} />
            <Route path="/Address" element={<Address />} />
            <Route
              path="/GetcategorySubcategory"
              element={<GetcategorySubcategory />}
            />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/my-account/" element={<WebLogin />} />
            <Route path="/Register" element={<WebRegister />} />
            <Route path="/return-policy/" element={<ReturnPolicy />} />
            <Route path="/delivery-information/" element={<Delivery />} />
            <Route path="/shipping-policy/" element={<ShippingPolicy />} />
            <Route
              path="/pricing-and-payments-policy/"
              element={<PaymentPolicy />}
            />
            <Route path="/disclaimer-policy/" element={<DisclaimerPolicy />} />
            <Route
              path="/prebooking-terms-and-conditions/"
              element={<PrebookingPolicy />}
            />
            <Route path="/refund-return/" element={<RefundReturn />} />
            <Route path="/terms-of-service/" element={<TermsOfServices />} />
            <Route path="/privacy-policy-2/" element={<PrivacyPolicy />} />
            <Route path="/faq/" element={<FAQ />} />
            <Route path="/how-to/" element={<UseIt />} />
            <Route path="/track-your-order/" element={<AllOrders />} />
            <Route path="/vendor-register/" element={<SellerDashboard />} />
            <Route path="/SellerRegister" element={<SellerRegister />} />
            <Route path="/GstRegistration" element={<GstRegistration />} />
            <Route path="/SellerLogin" element={<SellerLogin />} />
            <Route path="/ThankYouPage" element={<ThankYouPage />} />
            <Route path="/TopSellDetails" element={<TopSellDetails />} />
            <Route path="/offers" element={<Coupons />} />
            <Route
              path="/cancellation-and-return-policy/"
              element={<CancelAndReturn />}
            />
            <Route
              path="/category/:category/:subcategory/"
              element={<ShowSubCategory />}
            />
            <Route
              path="/category/:category/:title/:id"
              element={<ProductDetails />}
            />
            <Route path="/ViewAllCategory" element={<ViewAllCategory />} />

            <Route
              path="/ShowCategoryData/:category?/:id/:subCategoryName?"
              element={<ShowCategoryData />}
            />

            <Route path="/Getaddress" element={<Getaddress />} />
            <Route path="/OtpScreen" element={<OtpScreen />} />
            <Route path="/ViewAllBrand" element={<ViewAllBrand />} />
            <Route path="/:brand/:id/:name?" element={<ShowBrandData />} />

            {/* OtpScreen */}
          </Routes>
        </div>
      </Provider>
    </div>
  );
}

export default App;
